import { useState } from "react";
import Navbar from "./Navbar";
import FileBoard from "./FileBoard";
import GeneratedFiles from "./GeneratedFiles"; // Nowy komponent
import "../styles/Documents.css";

export function Dashboard() {
  const [activeTab, setActiveTab] = useState<"files" | "automations" | "generatedFiles">("files");

  return (
    <div className="dashboard-container">
      <div className="dashboard-content">
        <Navbar activeTab={"files"} setActiveTab={function (tab: "files" | "automations" | "generatedFiles"): void {
          throw new Error("Function not implemented.");
        } } />
        <div className="main-content">
        <div>
      <h2>📂 Wygenerowane pliki</h2>
      <p>Tu pojawią się pliki wygenerowane przez automatyzacje.</p>
    </div>          
        </div>
      </div>
    </div>
  );
}
